import { Row, Col, Card, Badge, Form, Stack } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { formInfoReducer, ACTIONS } from "../WebServiceFormDataReducer";
import { useReducer, useRef, useEffect, useState } from "react";
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { FormTextInput } from "Components/Forms/FormInput";
import { TextButton } from "Components/Button";
import { getGeneratePWD, getWSAccountInfo, submitEditWSAccount, validateWSPwd } from "../WebServiceAxiosFuncs";
import { store } from 'Store';
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import { useDispatch } from "react-redux";
import PasswordRuleChecker from "Components/PasswordRuleChecker/PasswordRuleChecker";
import { WS_PASSWORD_RULE_ACTIONS, webServicePasswordRuleReducer } from "../WebServicePasswordRuleReducer";
import PasswordStrengthMeter from "Components/PasswordStrengthMeter/PasswordStrengthMeter";


const nameConverter = {
  "status": "orgStatus",
  "password": "password"
}

const EditWebServiceAccount = () => {

  /*
   * consts & hooks
   */
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [passedData, setPassedData] = useState(location.state?.wsAccountInfo);
  const loginState = store.getState().loginInfo;
  const filter = location.state?.filter;
  const token = "Bearer " + loginState.token;
  const passwordTypesList = [
    "Uppercase character",
    "Lowercase character",
    "Number",
    "Valid Special characters: ! @ # $ % & * ( ) _ = + - [ ] ?"
  ];

  const initialState = {
    data: '',
    loading: true,
    error: null,
  };
  const [formInfo, formInfoDispatch] = useReducer(formInfoReducer, initialState);
  const [webServicePasswordRule, webServicePasswordRuleDispatch] = useReducer(webServicePasswordRuleReducer, {
    lengthCheck: false,
    // 3 of 4 checkers 
    characterCheck: {
      uppercaseCheck: false,
      lowercaseCheck: false,
      numberCheck: false,
      //: ! @ # $ % & * ( ) _ = + - [ ] ?
      specialCharCheck: false
    },
    orgIdCheck: false,
    historyCheck: false,
    countLimitCheck: true
  });

  // form field config
  const formFieldDisplay = {
    orgStatus: {
      type: 'radio',
      id: 'orgStatus',
      name: 'orgStatus',
      display: {
        label: 'Status',
        description: ""
      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    password: {
      type: 'text',
      id: 'newPWDField',
      name: 'password',
      display: {
        label: 'Type or Generate Password',
        description: "",
        title: "",
      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    }
  }

  /*
   * Functions
  */
  // Date format: mm/dd/yyyy 
  const handleDateFormat = (time) => {
    if (time == null) {
      return;
    }

    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
      </div>
    )
  }

  //Date format: mm/dd/yyyy hh:mm
  const handleTimeStamp = (time) => {
    if (time == null) {
      return;
    }

    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hh = date.getHours();
    let mm = date.getMinutes();

    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}&nbsp;
        {hh < 10 ? "0" + hh : hh}&#58;
        {mm < 10 ? "0" + mm : mm}

      </div>
    )
  }

  // display error after api call
  const dispErrors = (fieldName) => {
    var data = formInfo.data[fieldName];
    var dispData = formFieldDisplay[fieldName];
    return (
      <div>
        {data.validation.errors.length > 0 ? data.validation.errors.map((errorText, index) =>
          <Stack key={dispData.name + "Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
            <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
            <div>{errorText}</div>
          </Stack>

        ) : null}
      </div>
    );
  }

  // display label config
  const dispLabel = (fieldName, isHidden, getColLabelSizes, alignment, multi) => {

    var data = formInfo.data[fieldName];
    var dispData = formFieldDisplay[fieldName];

    //console.log("print out data, dispData, fieldName", data, dispData, fieldName);

    if (alignment == Row) {
      if (multi == true) {
        return (
          <Col hidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            <legend>
              {<span className="me-2">{dispData.display.label}</span>}
              {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
            </legend>
          </Col>
        );
      }
      else {
        return (
          <Form.Label visuallyHidden={isHidden} column
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            {<span className="me-2">{dispData.display.label}</span>}
            {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
          </Form.Label>
        );
      }
    }
    else {
      if (multi == true) {
        return (
          <Row hidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            <legend>
              {dispData.display.label}
              {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
            </legend>
          </Row>
        );
      }
      else {
        return (
          <Form.Label visuallyHidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            {dispData.display.label}
            {data.validation.required ? '' : /*<span className="optionalField"><br></br>optional</span>*/ <Badge bg="optional">Optional</Badge>}
          </Form.Label>
        );
      }

    }

  };

  // get value by key
  function getFieldValue (fieldName, data) {
    var values = data[fieldName];
    var dispValues = formFieldDisplay[fieldName];

    if (formInfo.loading) {
      return '';
    }
    else {
      var type = dispValues.type;
      switch (type) {

        case "text":
          if (values.value != null) {
            return values.value;
          }
          return "";
        case "radio":
          if (values != null) {
            var arr = values.radioButtons;
            for (var x = 0; x < arr.length; x++) {
              if (arr[x].isChecked) {
                return arr[x].value;
              }
            }
          }
          return null;
      }
    }
  }

  function addErrorMessages (fieldName, errorFieldName, data, isFirst) {
    //console.log("addErrorMessages", fieldName, errorFieldName, data);
    var d = data.fieldErrors;
    var values = d[errorFieldName];
    if (values != null) {
      var field = formFieldDisplay[fieldName];
      var type = field.type;
      var err = values.errorMessages;

      if (isFirst == true) {
        (field.InputRef).current.focus();
        //console.log("ISFIRST");
      }

      switch (type) {
        case "text":
          formInfoDispatch({
            type: ACTIONS.TEXT_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
        case "radio":
          formInfoDispatch({
            type: ACTIONS.RADIO_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
      }
    }
  }

  function clearErrorMessages (data) {
    for (const [key, value] of Object.entries(data)) {
      var t = formFieldDisplay[key];
      var fieldName = key;
      switch (t.type) {
        case "text":
          formInfoDispatch({
            type: ACTIONS.TEXT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
        case "radio":
          formInfoDispatch({
            type: ACTIONS.RADIO_REMOVE_ERRORS,
            name: fieldName
          })
          break;
      }
    }
  }

  const handleRadioChange = (e) => {
    formInfoDispatch({
      type: ACTIONS.RADIO_CHANGE,
      value: e.target.value,
      name: e.target.name
    })
  }

  // check password rule: 
  const checkPasswordRule = (value) => {

    /**
     * state structure
    {
      lengthCheck: false,
      // 3 of 4 checkers 
      characterCheck: {
        uppercaseCheck: false,
        lowercaseCheck: false,
        numberCheck: false,
        //: ! @ # $ % & * ( ) _ = + - [ ] ?
        specialCharCheck: false
      },
      orgIdCheck: true,
      historyCheck: true,
      countLimitCheck: true
    }
    */

    let lengthCheck = false;
    let characterCheck = false;
    let orgIdCheck = true;
    let countLimitCheck = !passedData?.reachedPwdChangeCntMaxToday;
    let characterCheckValidCount = 0;

    //console.log("print out checkPasswordRule countLimitCheck", countLimitCheck);

    // empty check then reset
    if (value === "") {
      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.SET_INITIAL_DATA,
        name: null,
        value: null
      })

      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_DAILY_CHANGE_COUNT,
        name: "countLimitCheck",
        value: !passedData?.reachedPwdChangeCntMaxToday
      })

      return;
    }

    // length check
    if (value.length >= 16 && value.length <= 24) {
      lengthCheck = true;

      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_LENGTH,
        name: "lengthCheck",
        value: true
      })

    } else {

      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_LENGTH,
        name: "lengthCheck",
        value: false
      })
    }

    // uppercase check
    let uppercase = /[A-Z]/;
    if (uppercase.test(value)) {

      characterCheckValidCount++;

      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_UPPER_CASE,
        name: "uppercaseCheck",
        value: true
      });
    } else {
      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_UPPER_CASE,
        name: "uppercaseCheck",
        value: false
      });
    }

    // lowercase check
    let lowercase = /[a-z]/;
    if (lowercase.test(value)) {

      characterCheckValidCount++

      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_LOWER_CASE,
        name: "lowercaseCheck",
        value: true
      });
    } else {
      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_LOWER_CASE,
        name: "lowercaseCheck",
        value: false
      });
    }

    // number check
    let numberChecker = /\d/;
    //console.log("numberChecker", numberChecker.test(value), value);
    if (numberChecker.test(value)) {

      characterCheckValidCount++;

      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_NUMBER,
        name: "numberCheck",
        value: true
      });

    } else {
      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_NUMBER,
        name: "numberCheck",
        value: false
      });
    }

    // special character check
    let specialCharCheck = /[@!#$%&*()_+\-=\[\]?]/;
    //console.log("specialCharCheck", specialCharCheck.test(value), value);
    if (specialCharCheck.test(value)) {

      characterCheckValidCount++;

      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_SPECIAL_CHARACTER,
        name: "specialCharCheck",
        value: true
      });

    } else {
      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_SPECIAL_CHARACTER,
        name: "specialCharCheck",
        value: false
      });
    }

    // org id check
    if (value.toLowerCase().includes(passedData?.psoId.toString().toLowerCase())) {

      orgIdCheck = false;

      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_ORG_ID,
        name: "orgIdCheck",
        value: false
      });

    } else {
      webServicePasswordRuleDispatch({
        type: WS_PASSWORD_RULE_ACTIONS.CHECK_ORG_ID,
        name: "orgIdCheck",
        value: true
      });
    }

    webServicePasswordRuleDispatch({
      type: WS_PASSWORD_RULE_ACTIONS.CHECK_PASSWORD_HISTORY,
      name: "historyCheck",
      value: true
    });

    if (characterCheckValidCount >= 3) {
      characterCheck = true;
    }

    return lengthCheck && characterCheck && orgIdCheck && countLimitCheck;

  }

  // contains 3 of the 4 character types
  const checkCharacterTypes = () => {
    let i = 0;
    for (const key in webServicePasswordRule.characterCheck) {
      if (webServicePasswordRule.characterCheck[key]) {
        i++;
      }
      if (i >= 3) {
        return true;
      }
    }

    return false;
  }

  const handleCancel = () => {
    if (passedData?.psoppcAdmin && passedData?.psoppcAdmin === true) {
      navigate("/manage/wsa", { state: { filter } });
      return;
    }

    navigate("/dashboard");
  }

  /**
   * 
   * APIs & useEffects
   */

  const handleInputTextChange = (e) => {

    const fieldName = e.target.name;
    const value = e.target.value;

    if (checkPasswordRule(value)) {
      // validate pwd 
      validateWSPwd(token, passedData, value, getFieldValue)
        .then((res) => {
          if (res !== null && res !== undefined) {
            var statusCode = res.data.status;
            switch (statusCode) {
              case STATUSES.ERROR.code:
                if (res.data.fieldErrors?.password && res.data.fieldErrors?.password?.errorMessages?.length != 0) {
                  res.data.fieldErrors?.password?.errorMessages.forEach(item => {
                    //console.log("res.data.globalErrorMessageList", item);
                    // set pwd hisotry check flag
                    if (item.includes("4")) {
                      webServicePasswordRuleDispatch({
                        type: WS_PASSWORD_RULE_ACTIONS.CHECK_PASSWORD_HISTORY,
                        name: "historyCheck",
                        value: false
                      });
                    }
                  });
                };
                break;
            }
          }
        }).catch(function (error) {
          setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
              visible: true,
              title: ERROR_MESSAGES.DATA_ERROR.title,
              msg: ERROR_MESSAGES.DATA_ERROR.message,
              showContactHelp: true
            },
            redirect: {
              redirect: false,
              redirectFirst: false,
              path: "",
              data: {}
            },
            error: error
          });
          return error.response;
        })
    }
    // else {
    //   webServicePasswordRuleDispatch({
    //     type: WS_PASSWORD_RULE_ACTIONS.CHECK_PASSWORD_HISTORY,
    //     name: "historyCheck",
    //     value: false
    //   });
    // }

    formInfoDispatch({
      type: ACTIONS.TEXT_CHANGE,
      value: value,
      name: fieldName
    });
  }

  const loadFormInfo = (ACTIONS, formInfoDispatch, handleRadioChange, handleInputTextChange) => {
    //console.log("print out loadFormInfo", passedData);
    let data = {
      orgStatus: {
        radioButtons: [
          {
            id: "0",
            label: "Active",
            name: "orgStatus",
            value: 1,
            title: "Is Active Organization",
            isChecked: passedData?.acctStatus === "Active",
            onChange: handleRadioChange,
            disabled: false
          },
          {
            id: "1",
            label: "Inactive",
            name: "orgStatus",
            value: 0,
            title: "Is Inactive Organization",
            isChecked: passedData?.acctStatus === "Inactive",
            onChange: handleRadioChange,
            disabled: false
          }
        ],
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
      },
      password: {
        value: "",
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      }
    }

    formInfoDispatch({
      type: ACTIONS.SET_INITIAL_DATA,
      data: data,
      loading: false
    })
  }

  // initial page form info loading
  useEffect(() => {
    //console.log("printout useeffect passedData", passedData);
    getWSAccountInfo(token, passedData)
      .then((res) => {
        if (res !== null && res !== undefined) {
          //console.log("getWSAccountInfo2()", res);
          var statusCode = res.data.status;
          if (statusCode < 0) {
            statusCode = STATUSES.ERROR.code;
          }
          switch (statusCode) {
            case STATUSES.ERROR.code:
              if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {

                if (res.data.data?.reachedPwdChangeCntMaxToday) {
                  //console.log("setpasseddata", res.data.data);
                  setPassedData(res.data.data);
                  webServicePasswordRuleDispatch({
                    type: WS_PASSWORD_RULE_ACTIONS.CHECK_DAILY_CHANGE_COUNT,
                    name: "countLimitCheck",
                    value: !res.data.data.reachedPwdChangeCntMaxToday
                  });
                }

                setGlobalErrorStatus({
                  dispatch: dispatch,
                  popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: res.data.globalErrorMessageList,
                    showContactHelp: false
                  },
                  redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                  }
                })
              };
              break;
            case STATUSES.SUCCESS.code:
              setPassedData(res.data.data);
              webServicePasswordRuleDispatch({
                type: WS_PASSWORD_RULE_ACTIONS.CHECK_DAILY_CHANGE_COUNT,
                name: "countLimitCheck",
                value: !res.data.data.reachedPwdChangeCntMaxToday
              });
              break;
          }
        }
      }).catch((error) => {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });

        return error.response;
      });

    loadFormInfo(ACTIONS, formInfoDispatch, handleRadioChange, handleInputTextChange);

  }, []);

  useEffect(() => {
    loadFormInfo(ACTIONS, formInfoDispatch, handleRadioChange, handleInputTextChange)
  }, [passedData]);

  const handleGeneratePWD = () => {
    if (passedData?.acctStatus !== undefined && passedData?.acctStatus !== null) {
      getGeneratePWD(getFieldValue, ACTIONS, formInfoDispatch, formInfo, handleRadioChange, handleInputTextChange, token, passedData)
        .then((res) => {
          //console.log("handleGeneratePWD", res);
          var statusCode = res.data.status;
          if (statusCode < 0) {
            statusCode = STATUSES.ERROR.code;
          }
          switch (statusCode) {
            case STATUSES.ERROR.code:
              if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
                setGlobalErrorStatus({
                  dispatch: dispatch,
                  popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: res.data.globalErrorMessageList,
                    showContactHelp: false
                  },
                  redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                  }
                })
              };
              break;
            case STATUSES.SUCCESS.code:
              webServicePasswordRuleDispatch({
                type: WS_PASSWORD_RULE_ACTIONS.PASS,
                name: null,
                value: null
              });
              webServicePasswordRuleDispatch({
                type: WS_PASSWORD_RULE_ACTIONS.CHECK_DAILY_CHANGE_COUNT,
                name: "countLimitCheck",
                value: !passedData.reachedPwdChangeCntMaxToday
              });
              break;
          }
        }).catch(function (error) {
          //console.log("handleGeneratePWD", error);
          setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
              visible: true,
              title: ERROR_MESSAGES.DATA_ERROR.title,
              msg: ERROR_MESSAGES.DATA_ERROR.message,
              showContactHelp: true
            },
            redirect: {
              redirect: false,
              redirectFirst: false,
              path: "",
              data: {}
            },
            error: error
          });
          return error.response;
        });
    } else {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: "There is no Web Service Account selected.",
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        }
      });
    }
  }

  const handleSubmit = () => {
    if (passedData?.acctStatus !== undefined && passedData?.acctStatus !== null) {
      submitEditWSAccount(token, passedData, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue)
        .then((res) => {
          if (res !== null && res !== undefined) {
            //console.log("submitCreateWSAccount", res);
            var statusCode = res.data.status;
            switch (statusCode) {
              case STATUSES.ERROR.code:
                if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
                  setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                      visible: true,
                      title: ERROR_MESSAGES.GENERAL_ERROR.title,
                      msg: res.data.globalErrorMessageList,
                      showContactHelp: true
                    },
                    redirect: {
                      redirect: false,
                      redirectFirst: false,
                      path: "",
                      data: {}
                    }
                  })
                };
                break;
              case STATUSES.SUCCESS.code:
                setGlobalSuccessStatus({
                  dispatch: dispatch,
                  popupData: {
                    visible: true,
                    title: "Success!",
                    msg: res.data.message,
                    showContactHelp: false
                  },
                  redirect: {
                    redirect: true,
                    redirectFirst: true,
                    path: passedData?.psoppcAdmin === true ? "/manage/wsa" : "/dashboard",
                    data: {}
                  }
                });
                break;
            }
          }
        }).catch(function (error) {
          //console.log("handleSubmit()", error);
          setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
              visible: true,
              title: ERROR_MESSAGES.DATA_ERROR.title,
              msg: ERROR_MESSAGES.DATA_ERROR.message,
              showContactHelp: true
            },
            redirect: {
              redirect: false,
              redirectFirst: false,
              path: "",
              data: {}
            },
            error: error
          });
          return error.response;
        })
    } else {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: "There is no Web Service Account selected.",
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        }
      });
    }
  }

  return (
    <>
      {formInfo.loading ? null :
        <Row>
          <Col xl={11} lg={11} md={11} sm={12}>
            <Card className="p-4">
              <Card.Body className="text-start">
                {/* Page title switch based on the user role */}
                <h1 id="mainContent" className="header1 text-start mb-3 blue bold">
                  {passedData?.psoppcAdmin && passedData?.psoppcAdmin === true ?
                    "Edit Web Service Account" :
                    "Change Web Service Password"}
                </h1>
                <h2 className="text-start mb-2 form-title">Web Service Account</h2>
                <br />
                <Form>
                  <Row className="mb-1">
                    <Col lg={3}>
                      <span className="name form-label-style">Organization ID</span>
                    </Col>
                    <Col lg={6}>
                      {passedData?.psoId}
                    </Col>
                  </Row>
                  <br />
                  <Row className="mb-1">
                    <Col lg={3}>
                      <span className="name form-label-style">Organization Name</span>
                    </Col>
                    <Col lg={6}>
                      {passedData?.psoName}
                    </Col>
                  </Row>
                  <br />
                  <Row className="mb-1">
                    <Col lg={3}>
                      <span className="name form-label-style">Password Changed By</span>
                    </Col>
                    <Col lg={6}>
                      {passedData?.passwordChangedBy}
                    </Col>
                  </Row>
                  <br />
                  <Row className="mb-1">
                    <Col lg={3}>
                      <span className="name form-label-style">Password Changed Date</span>
                    </Col>
                    <Col lg={6}>
                      {handleTimeStamp(passedData?.passwordChangeDate)}
                    </Col>
                  </Row>
                  <br />
                  <Row className="mb-1">
                    <Col lg={3}>
                      <span className="name form-label-style">Password Expiration Date</span>
                    </Col>
                    <Col lg={6}>
                      {handleDateFormat(passedData?.passwordExpireDate)}
                    </Col>
                  </Row>
                  <br />
                  {passedData?.psoppcAdmin && passedData?.psoppcAdmin === true ?
                    <>
                      <FormTextInput orgType={"Admin"} fieldName="orgStatus" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 7 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                      <br />
                    </> : <br />
                  }
                  <Row>
                    <Col lg={7}>
                      <div className="text-start mb-2 passwordRulesTitle">Password Creation Rules</div>
                      <div className="mb-2">
                        <PasswordRuleChecker flag={webServicePasswordRule.lengthCheck} content={"1. Contains 16-24 Characters"} />
                      </div>
                      <div className="mb-2">
                        <PasswordRuleChecker flag={checkCharacterTypes(webServicePasswordRule.characterCheck)} content={"2. Contains 3 of the 4 character types:"} />
                      </div>
                      <ul className="mb-2 ms-1">
                        {passwordTypesList.map(item => {
                          return (
                            <li key={item}>
                              {item}
                            </li>)
                        })}
                      </ul>
                      <div className="mb-2">
                        <PasswordRuleChecker flag={webServicePasswordRule.orgIdCheck} content={"3. Does not contain the Organization ID."} />
                      </div>
                      <div className="mb-2">
                        <PasswordRuleChecker flag={webServicePasswordRule.historyCheck} content={"4. Cannot be any password used in the past 12 months."} />
                      </div>
                      {passedData?.psoppcAdmin && passedData?.psoppcAdmin === true ?
                        null :
                        <div className="mb-2">
                          <PasswordRuleChecker flag={webServicePasswordRule.countLimitCheck} content={"5. Cannot be changed more than 3 times daily."} />
                        </div>}
                    </Col>
                    <Col lg={5}>
                      <FormTextInput orgType={"Admin"} fieldName="password" hideLabel={false} horizontalForm={{ is: false, labelCols: { lg: 3, md: 5 }, inputCols: { lg: 9 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={24}></FormTextInput>
                      <PasswordStrengthMeter passwordRule={webServicePasswordRule} value={getFieldValue("password", formInfo.data)} colConfig={{ labelCols: { lg: 4, md: 4 }, inputCols: { lg: 5 } }}></PasswordStrengthMeter>
                      <TextButton
                        variant="outline"
                        disabled={passedData?.reachedPwdChangeCntMaxToday && !passedData?.psoppcAdmin}
                        onClick={handleGeneratePWD}
                        content={"Generate Password"}
                      ></TextButton>
                      <br />
                    </Col>
                  </Row>
                  <br />
                  {/* <Row className="mb-1"> */}
                  <Row className="mb-1">
                    <Col>
                      <TextButton
                        className="me-3"
                        variant="normal"
                        disabled={passedData?.reachedPwdChangeCntMaxToday && !passedData?.psoppcAdmin}
                        onClick={handleSubmit}
                        content={"Submit"}
                      >
                      </TextButton>
                      <TextButton
                        variant="outline"
                        onClick={handleCancel}
                        content={"Cancel"}
                      >
                      </TextButton>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row >}
    </>
  )
}

export default EditWebServiceAccount;